const LoginIcon = ({ color = false, className = '' }) => {
  const fillColor = color ? color : 'currentColor';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_31_26)">
        <path
          d="M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM7 21.797V21C7 18.243 9.243 16 12 16C14.757 16 17 18.243 17 21V21.797C15.499 22.566 13.799 23 12 23C10.201 23 8.501 22.566 7 21.797ZM18 21.215V21C18 17.691 15.309 15 12 15C8.691 15 6 17.691 6 21V21.215C2.992 19.25 1 15.853 1 12C1 5.935 5.935 1 12 1C18.065 1 23 5.935 23 12C23 15.853 21.008 19.25 18 21.215ZM12 5C9.794 5 8 6.794 8 9C8 11.206 9.794 13 12 13C14.206 13 16 11.206 16 9C16 6.794 14.206 5 12 5ZM12 12C10.346 12 9 10.654 9 9C9 7.346 10.346 6 12 6C13.654 6 15 7.346 15 9C15 10.654 13.654 12 12 12Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_31_26">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LoginIcon;
